<script>
import Layout from '@layouts/auth'

export default {
  page: {
    title: '404',
    meta: [{ name: 'description', content: '404' }],
  },
  components: { Layout },
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
                    <div class="col-md-8 col-lg-6 col-xl-5">
                        <div class="card">

                            <div class="card-body p-4">

                                <div class="error-logo text-center">
                                    <img src="@assets/images/alcaldia-logo-texto.png" height="160" border="0" />
                                </div>

                                <div class="text-center">
                                    <h3 class="mt-4 text-uppercase font-weight-bold">No encontrado</h3>
                                    <p class="text-muted mb-0 mt-3" style="line-height: 20px;">Parece que te has equivocado de camino. No te preocupes...
                                         nos pasa a los mejores. Es posible que desees comprobar tu conexión a Internet.</p>

                                    <router-link tag="a" to="/" class="btn btn-primary mt-3"><i class="mdi mdi-reply mr-1"></i> Volver al inicio</router-link>
                                </div>

                            </div> <!-- end card-body -->
                        </div>
                        <!-- end card -->

                    </div> <!-- end col -->
                </div>
  </Layout>
</template>

<style lang="scss" >
.error-logo img { 
  filter: grayscale(100%) saturate(0.3) opacity(0.5) contrast(184%); 
  -webkit-filter: grayscale(100%) saturate(0.3) opacity(0.5) contrast(184%); 
}
</style>
